import React, { useState } from "react";
import {
  IconButton,
  Typography,
  Paper,
  Menu,
  MenuItem,
  makeStyles,
  DialogTitle,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  Grid,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import getColor from "../sasl/models/status/statusColors";
import StatusTextDispaly from "./POColumns/StatusTextDispaly";
import BatchDetailsUnitBox from "../sasl/batch/viewProcessInformation/BatchDetailsUnitBox";
import ExceptionDetails from "../sasl/batch/viewBatchQualityEvents/ExceptionDetails";
import ViewStructuredInformation from "../sasl/batch/ViewStructuredInformation";
import ViewRmPMLots from "./../../common/sasl/batch/ViewRMPMLots/index";
import QuickView from "../sasl/common/drawer/QuickView";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import { batch } from "react-redux";
// import ViewRmPMLots from './../ViewRMPMLots/index'

const useStyles = makeStyles((theme) => ({
  popover: {
    left: "0px !important", // Forces left alignment
    transformOrigin: "left top !important",
  },
  paper: {
    width: "210px",
    transform: "translateY(5px)", // Slightly lower for better UX
  },
}));

const BatchColumnStatusRoute = (props) => {
  const { row, featuresAccess, poDashboardBatch } = props;
  const [loading, setLoading] = useState(false);
  const [batchDetails, setBatchDetails] = useState({ existingCustomFiles: [] });
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [openQuickView, setOpenQuickView] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const fetchBatchDetails = () => {
    setLoading(true);

    const data = {
      schrockenDeliveryScheduleBatchID: row?.batchDetails?.schrockenDeliveryScheduleBatchID,
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDeliveryScheduleBatchDetails`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          setBatchDetails(res.data.data);
          // setBatchDetails((prevDetails) => ({
          //   ...prevDetails,
          //   existingCustomFiles: res.data.data.existingCustomFiles,
          // }));
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const options = [
    //  {
    //   label: "View process information",
    //   component: <BatchDetailsUnitBox batchDetails={batchDetails} view={true} />,
    //   title:"View process information",
    // },
    // {
    //   label: "View quality events",
    //   component: <ExceptionDetails batchDetails={batchDetails} showExceptionDetails={true} row={row}/>,
    //   title:"View quality events",
    // },
    {
      label: "View Consumption",
      title: "View Consumption",
      component: <ViewRmPMLots
        showRMPMDetails={true}
        row={row}
        batchDetails={batchDetails}
        targetQuantity={row?.scheduleLineDetails?.targetQuantity}
        selectedDeliveryBatchID={row?.batchDetails?.schrockenDeliveryScheduleBatchID}
        poDashboardBatch={poDashboardBatch}
      />,
    },
    // {
    //   label: "View Digitized Information",
    //   component: <ViewStructuredInformation
    //     batchDetails={batchDetails}
    //     targetQuantity={row?.scheduleLineDetails?.targetQuantity}
    //     schrockenDeliveryScheduleID={batchDetails?.schrockenDeliveryScheduleID}
    //   />,
    //   title: "View Digitized Information",
    // },
    {
      label: "View Batch Details",
      title: "View Batch Details",
      isQuickView: true, // Special flag to identify QuickView option
    },
  ];

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => {
    if (option.isQuickView) {
      setOpenQuickView(true);
    } else {
      // if (option.label !== "View Batch Details") {
      //   fetchBatchDetails();
      // }
      setSelectedComponent(option.component);
      setOpenDialog(true);
    }
    handleCloseMenu();
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedComponent(null);
  };

  const handleCloseQuickView = () => {
    setOpenQuickView(false);
  };


  const selectedTitle = options.find((option) => option.component?.type === selectedComponent?.type)?.title || "";

  // const filteredOptions = options.filter(option => {
  //   if (option.label === "View consumption") {
  //     return featuresAccess.batchDropdownConsumption;
  //   }
  //   if (option.label === "View Digitized Information") {
  //     return featuresAccess.batchDropdownDigitizedInformation;
  //   }
  //   return true; // Include other options by default
  // });

  const filteredOptions = featuresAccess && Object.keys(featuresAccess).length > 0
    ? options.filter(option => {
      if (option.label === "View Consumption") {
        return featuresAccess.batchDropdownConsumption;
      }
      if (option.label === "View Digitalized Information") {
        return featuresAccess.batchDropdownDigitizedInformation;
      }
      if (option.label === "View Batch Details") {
        return true; // Always show View Batch Details option
      }
      return true; // Include other options by default
    })
    : options;


  return (
    <div>
      <div
        style={{
          display: "flex",
          cursor: "pointer",
          textAlign: "center"
        }}
        className="bg-color-status-dropdown"
      >
        <StatusTextDispaly
          statusText={row?.batchDetails?.batchStatusText === 'Planned' ? 'Shipped' : row?.batchDetails?.batchStatusText}
          bgColor={getColor(row?.batchDetails?.batchStatusID)}
        />
        <IconButton
          onClick={handleClick}
          style={{ border: "1px solid", borderRadius: "0", padding: "1px 2px" }}
          size='small'

        >
          <ArrowDropDownIcon />
        </IconButton>
      </div>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        classes={{ paper: classes.paper }}
        PopoverClasses={{ root: classes.popover }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        getContentAnchorEl={null}
      >
        {filteredOptions.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => handleMenuItemClick(option)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
      {/* Render selected component based on the selected option */}
      {/* <div style={{ marginTop: "20px" }}>
        {selectedOption === "View Process Information" && <BatchDetailsUnitBox />}
        {selectedOption === "View Quality Events" && <ExceptionDetails />}
        {selectedOption === "View RM/PM Lot" && <ViewRmPMLots />}
        {selectedOption === "View Digitized Information" && <ViewStructuredInformation />}
      </div> */}

      {/* Full-Screen Dialog */}
      <Dialog fullScreen open={openDialog} onClose={handleCloseDialog}>
        <DialogActions>
          <Grid
            style={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              alignItems: "start",
            }}>


            <Grid style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "start",
              marginTop: "0.3rem"
            }}>
              <Button
                onClick={handleCloseDialog}
                style={{ color: "black", fontWeight: 550, textTransform: "none" }}
              >
                <KeyboardArrowLeftIcon fontSize='19' color='black' />
                Back
              </Button>
              {/* <Typography variant="h5" style={{fontWeight:"bold",marginLeft:"2rem"}}>
            View Process information
          </Typography> */}
              <Typography variant="h6" style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                {/* {options.find((option) => option.component === selectedComponent)?.label || ""} */}
                {selectedTitle}
              </Typography>
            </Grid>
            <Grid>
              {/* bdbdbd */}
              <div style={{ width: "97vw", height: "1.5px", backgroundColor: "#bdbdbd", marginTop: "1rem" }}></div>
            </Grid>
          </Grid>
        </DialogActions>
        <DialogContent>{selectedComponent}</DialogContent>
      </Dialog>

      {/* QuickView Dialog */}
      {openQuickView && (
        <Dialog
          fullScreen
          open={openQuickView}
          onClose={handleCloseQuickView}
        >
          <QuickView
            schrockenDeliveryScheduleBatchID={row?.batchDetails?.schrockenDeliveryScheduleBatchID}
            schrockenDeliveryScheduleID={batchDetails?.schrockenDeliveryScheduleID}
            targetQuantity={row?.scheduleLineDetails?.targetQuantity}
            poQuantity={row?.scheduleLineDetails?.targetQuantity}
            setDialogOpen={handleCloseQuickView}
            qualityApprovalFlowFlag={batchDetails?.qualityApprovalFlowFlag}
            isApprovedButton={featuresAccess?.viewApproveRejectConsumedBatch}
            batchesData={poDashboardBatch}
            selectedBatch={row}
            poRowData={row}
            isFromPoDashboard={true}
            cmoBatchNumber={batchDetails?.cmoBatchNumber}
          />
        </Dialog>
      )}
    </div>
  );
};

export default BatchColumnStatusRoute;
